<template>
  <div class="card-form">
      <page-main
        :tableData="tableData"
        :tablePage="page"
        :loading="loading"
        @reload="reload"
        @openEditFormDialog="openEditFormDialog"
      >
        <page-header
          ref="header"
          slot="header"
          @query="getData"
          @reset="resetPage"
          @openEditFormDialog="openEditFormDialog"
        />
        <pagination
          size="mini"
          align="right"
          slot="pager"
          :current-page="page.curPage"
          :page-size="page.pageSize"
          :page-total="page.pageTotal"
          @change="handlePaginationChange"
        />
      </page-main>
      <el-dialog
        v-if="editFormDialogOptions.visible"
        show-close
        visible
        width="700px"
        :title="editFormDialogOptions.title"
        :close-on-click-modal="false"
        :before-close="() => $refs.editForm.cancel()"
      >
        <edit-form
          ref="editForm"
          :resAttributeCode="editFormDialogOptions.resAttributeCode"
          :resAttributeType="editFormDialogOptions.resAttributeType"
          :disabled="editFormDialogOptions.disabled"
          :createDateVisible="editFormDialogOptions.createDateVisible"
          :params="editFormDialogOptions.params"
          @reload="reload"
          @close="closeEditFormDialog"
        />
        <span slot="footer">
          <el-button size="small" @click="$refs.editForm.cancel()"
            >{{this.$l('INDEX.btn_cancel') || '取消'}}</el-button
          >
          <el-button type="primary" size="small" @click="$refs.editForm.save()"
          v-if="!editFormDialogOptions.disabled"
            >{{this.$l('INDEX.btn_save') || '保存'}}</el-button
          >
        </span>
      </el-dialog>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditForm from '../right-edit-form/index'
import store from '../../store'
export default {
  components: {
    PageHeader,
    PageMain,
    EditForm,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  computed: {
    selected() {
      return store.state.selected
    },
  },
  watch: {
    selected() {
      this.getData()
    },
  },
  methods: {
    getData(form) {
      if (!this.selected || !this.selected.resAttributeType) return
      this.loading = true
      this.$api
        .listResearchDictionaryApi({
          resAttributeType: this.selected.resAttributeType,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({type, params = {}}) {
      if (!this.selected || !this.selected.resAttributeType) {
        this.$message.warning(this.$l('tips_select_left_attribute_type') ||'请选择左侧属性类型')
        return
      }
      const types = {
        edit: this.$l("tips_edit") || "编辑市场属性字典信息",
        add: this.$l("tips_add") || "增加市场属性字典信息",
        detail: this.$l("tips_view") || "市场属性字典详情",
      }
      this.editFormDialogOptions = {
        visible: true,
        type,
        title: types[type],
        resAttributeCode: params.resAttributeCode,
        resAttributeType: this.selected.resAttributeType,
        disabled: type === "detail",
        createDateVisible: type != "add",
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
  },
}
</script>
